import { useEffect } from "react";
import { OtsAircraft } from "../../../Models/OtsAircraft";
import React from "react";
import { getAirborneLabelMessage } from "./AirborneLabelMessage";
import './RenderLocAirborneMessagesListView.scss';

interface RenderLocAirborneMessagesListViewProps {
    otsEvent: OtsAircraft; 
}

const RenderLocAirborneMessagesListView = React.memo(function RenderLocAirborneMessagesListView({otsEvent}: RenderLocAirborneMessagesListViewProps) {
    const NOT_APPLICABLE = "NotApplicable";
    const [airborneMessage, setAirborneMessage] = React.useState<string>("");
    const [isDiversion, setIsDiversion] = React.useState<boolean>(false);

    useEffect(() => {
        if (
            otsEvent?.IsAirborneAtCreate &&
            otsEvent?.EventTypeCategory === NOT_APPLICABLE
          ) {
            const {label, isDiversion} = getAirborneLabelMessage(otsEvent);
            setAirborneMessage(label);
            setIsDiversion(isDiversion);
          }
          else{
            setAirborneMessage("");
            setIsDiversion(false);
          }
    }, [otsEvent]);

    return (
        <span>
            {airborneMessage ? (
            <span className={isDiversion?"render-airborne-diversion hide-loc-list":""}>{airborneMessage}</span>
        ) : (
            <span className="render-loc-list-view hide-loc-list">{otsEvent?.Location || ""}</span>
        )}
        </span>
    );
});

export default RenderLocAirborneMessagesListView;